var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrictAccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#353841;}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#71778a",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.239,10A4.589,4.589,0,0,1,17.374,13.4,3.7,3.7,0,1,0,15.239,10Zm-2.426,7.583a3.7,3.7,0,1,0-3.7-3.7A3.7,3.7,0,0,0,12.812,17.578Zm1.92.38a9.5,9.5,0,0,1-1.92.3,6.41,6.41,0,0,1-1.789-.364A4.513,4.513,0,0,0,6.5,22.573v3.843H19.124V22.573A4.351,4.351,0,0,0,14.733,17.959Zm5.74-3.681a8.512,8.512,0,0,1-1.744.245,2.919,2.919,0,0,1-1.354-.338,4.144,4.144,0,0,1-1.39,3,5.635,5.635,0,0,1,4.025,5.392l5.244.015V18.749A4.557,4.557,0,0,0,20.472,14.277ZM6.314,13.755a3.679,3.679,0,0,0,1.97-.572,4.583,4.583,0,0,1,1.723-2.923c0-.069.01-.138.01-.208a3.7,3.7,0,1,0-3.7,3.7ZM9.64,17.187a4.28,4.28,0,0,1-1.427-3.028c-.116-.009-.273.078-.39.078a5.831,5.831,0,0,1-1.6.273,4.7,4.7,0,0,1-1.572-.328A4.523,4.523,0,0,0,0,18.749v3.844l5.615-.014A5.636,5.636,0,0,1,9.64,17.187Z",
    transform: "translate(16.655 13.875)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictAccess);
export default __webpack_public_path__ + "static/media/restrict_access.17fe2123f5168be0a68d7d7c86167638.svg";
export { ForwardRef as ReactComponent };